(() => {
  const pad = (n) => String(Math.max(0, n)).padStart(2, '0');

  const update = (el) => {
    const end = el.dataset.endDate;
    const out = el.querySelector('[data-glory-countdown-output]');
    if (!end || !out) return;

    const endTime = new Date(end).getTime();
    if (Number.isNaN(endTime)) {
      el.hidden = true;
      return;
    }

    const diff = endTime - Date.now();
    if (diff <= 0) {
      el.hidden = true;
      return;
    }

    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const mins = Math.floor((diff % 3600000) / 60000);
    const secs = Math.floor((diff % 60000) / 1000);
    out.textContent = `${pad(days)}D · ${pad(hours)}H · ${pad(mins)}M · ${pad(secs)}S`;
  };

  const init = () => {
    document.querySelectorAll('[data-glory-countdown]').forEach((el) => {
      update(el);
      if (el.dataset.gloryCountdownReady === 'true') return;
      el.dataset.gloryCountdownReady = 'true';
      setInterval(() => update(el), 1000);
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
